import type { Middleware } from '@reduxjs/toolkit'

import { initSocketService, handleBrowserRouteChange } from '@features/websocket/socketService'
import { setCurrentPath } from '@store/modules/sockets/slice'

type ActionTypes = ReturnType<typeof setCurrentPath>

let initialized = false

export const socketMiddleware: Middleware = (store) => (next) => (actionRaw) => {
  const action = actionRaw as ActionTypes

  if (!initialized) {
    initialized = true
    initSocketService(store.dispatch)
  }

  if (action.type === setCurrentPath.type) {
    // route updated -> connect/disconnect WebSockets
    handleBrowserRouteChange(action.payload)
  }

  return next(action)
}
